"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IntlProvider;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../../helpers");

var _NestedIntlProvider = _interopRequireDefault(require("../NestedIntlProvider/NestedIntlProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IntlProvider(_ref) {
  var children = _ref.children,
      locale = _ref.locale;
  return /*#__PURE__*/_react.default.createElement(_NestedIntlProvider.default, {
    messages: (0, _helpers.getMessagesForLocale)((0, _helpers.getTranslations)(), locale),
    locale: locale
  }, children);
}